export default __webpack_public_path__ + "static/womanHandReddiCapsule 11.20.14 PM-9a78c8740f23fda939d886c74cd6525b.png";